"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@chakra-ui/react");
var _template = _interopRequireDefault(require("lodash/template"));
var _environment = _interopRequireDefault(require("@spothero/utils/environment"));
const buildCloudinarySrc = ({
  cloudinaryImageId,
  cloudinaryTemplate,
  cloudinaryCloudName,
  htmlWidth,
  htmlHeight,
  quality
}) => {
  const defaultTemplate = `https://res.cloudinary.com/${cloudinaryCloudName}/image/upload/$w_{{WIDTH}},$h_{{HEIGHT}},$q_{{QUALITY}}/c_fill,f_auto,fl_progressive,dpr_${_environment.default.isHighDensityDisplay() ? 2 : 1},h_$h,q_$q,w_$w/${cloudinaryImageId}`;
  const tmpl = cloudinaryTemplate ? cloudinaryTemplate : defaultTemplate;
  return (0, _template.default)(tmpl, {
    interpolate: /{{([\s\S]+?)}}/g // matches template vars in the format '{{ var }}' or '{{var}}'
  })({
    WIDTH: htmlWidth,
    HEIGHT: htmlHeight,
    QUALITY: quality
  });
};
const Image = ({
  isSSR,
  cloudinaryImageId,
  cloudinaryTemplate,
  cloudinaryCloudName,
  htmlWidth,
  htmlHeight,
  quality,
  lazyLoad,
  ...otherProps
}) => {
  const hasValidCloudinarySrc = (cloudinaryImageId || cloudinaryTemplate) && Boolean(htmlWidth) && Boolean(htmlHeight);
  let cloudinarySrc;
  if (hasValidCloudinarySrc) {
    cloudinarySrc = buildCloudinarySrc({
      cloudinaryImageId,
      cloudinaryTemplate,
      cloudinaryCloudName,
      htmlWidth,
      htmlHeight,
      quality
    });
  }
  const imageProps = {
    ...otherProps,
    src: cloudinarySrc || otherProps.src,
    htmlWidth,
    htmlHeight,
    ...(lazyLoad && {
      loading: 'lazy'
    })
  };
  if (isSSR) {
    return /*#__PURE__*/_react.default.createElement(_react2.Img, imageProps);
  } else {
    return /*#__PURE__*/_react.default.createElement(_react2.Image, imageProps);
  }
};
Image.defaultProps = {
  isSSR: false,
  quality: 50,
  cloudinaryCloudName: 'spothero'
};
var _default = exports.default = Image;